import { palette } from 'src/styles/colors';
import styled from 'styled-components';
import { layout } from '../../styles/layout';

export const LegalContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  padding: 80px 24px;

  // used !important to fully override the max-width other than 1440px, wich is the default for all div's directly under <Layout>
  max-width: 760px !important;
  width: 100%;

  table {
    table-layout: fixed;
    width: 100%;
    border: 2px solid ${palette.text};
    border-collapse: collapse;
    margin-bottom: 1.5em;

    tbody {
      tr {
        border-bottom: 2px solid ${palette.text};

        td {
          font-size: 1em;
          padding: 15px 3px;
          border: 1px solid ${palette.text};
          font-weight: 300;

          @media all and (max-width: ${layout.sm}) {
            font-size: 0.8em;
          }

          a {
            word-break: break-all;
            color: ${palette.snowFlower};
            text-decoration: none;
            font-weight: 400;
          }
        }
      }
    }
  }
`

export const PoliciesCatalog = styled.div`
  display: grid;
  row-gap: 1.875em;

  span {
    font-size: 1.2em;
  }
`

export const ParagraphLegalStyled = styled.p`
  margin-bottom: 30px;
  line-height: 1.7;
  font-family: Lato, Arial, sans-serif;
  font-weight: 300;
  font-size: 1em;

  a {
    color: ${palette.snowFlower};
    text-decoration: none;
    font-weight: 400;
  }

`

export const UnOrderedListLegalStyled = styled.ul`
  list-style: none;
  list-style-type: none;
  margin: 2em 0em 2em;
  padding: 0;

  & > li {
    margin-bottom: 20px;
    line-height: 1.7;
    font-family: Lato, Arial, sans-serif;
    font-weight: 300;
    font-size: 1em;
  }
`
export const OrderedListLegalStyled = styled.ol`
  margin: 0.5em 0em 2em;
  padding-left: 1.25em;

  & > li {
    margin-bottom: 0px;

    p {
      margin-bottom: 0px;
    }
  }
`
